import Footer from './Footer.jsx';
import {Navigate} from "react-router-dom";
import { useSelector } from 'react-redux';

const AuthLayout = ({children}) =>
{
	const loginSettings = useSelector((state) => state.loginSettings);
	const image = (loginSettings.image && loginSettings.image.content) ? 'data:'+loginSettings.image.mime+';base64,'+loginSettings.image.content : '';

	const token = localStorage.getItem("token");
	if (token && token !== '')
	{
		return <Navigate to="/"/>
	}

	return(
		<div className="App bg-gradient-to-tr from-bodyBGFrom to-bodyBGTo" style={{background: loginSettings.background}}>
			<div className="relative flex items-start gap-3 p-4 min-h-[calc(100vh-35px)]">
				<div className="grow !m-0 min-w-[16rem]">
					<div className="w-full flex justify-center">
						<div className="flex flex-wrap relative items-center justify-center">
							{image ? <div className="mt-5 text-center md:me-20 md:mt-40"><img src={image} className="max-h-[300px]" alt="Company"/></div> : null}
							<div className="mt-40 w-96">
								<div className="layers relative z-10"></div>
								<main className="content px-5 py-8">
									{children}
								</main>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer/>
		</div>
	)
}

export default AuthLayout;